import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash.map';
import filesize from 'filesize';
import { UploadAttachment } from './UploadAttachment';
import { AttachmentType } from '../../utils/enums';

export class AttachmentItem extends Component {
	renderAttachmentsIcon(type) {
		switch (type) {
			case 'application/pdf': {
				return <i className="fas fa-file-pdf attachments-list__icon attachments-list__icon--primary-dark" />;
			}
			default: {
				return <i className="fas fa-file attachments-list__icon attachments-list__icon--primary-dark" />;
			}
		}
	}

	render() {
		return (
			<div>
				<Fragment>
					<div className="consultations__title margin-top-25 margin-bottom-15">Załączniki</div>
					<div className="attachments-list">
						{map(this.props.items, (attachment, key) => (
							<a
								key={key}
								className="attachments-list__item"
								target="_blank"
								href={`${this.props.baseUrl}/${attachment.id}`}
							>
								{this.renderAttachmentsIcon(attachment.contentType)}
								{this.props.removeable && (
									<div className="attachments-remove">
										<a
											onClick={(e) => {
												e.preventDefault();
												this.props.onRemoveItem(key);
											}}
										>
											<i className="far fa-trash-alt" />
										</a>
									</div>
								)}
								<div className="attachments-list__name">{attachment.filename}</div>
								<div className="attachments-list__size">({filesize(attachment.size)})</div>
							</a>
						))}
					</div>
				</Fragment>
				<div>
					<UploadAttachment
						maxSize={this.props.maxSize}
						disabled={this.props.disabled}
						onUpload={async (file) => {
							let id = await this.props.uploadFile(file);
							if (id >= 0) {
								let { size, name, ...other } = file;
								this.props.onAddItem({
									id,
									size,
									filename: name,
									type: AttachmentType.Common,
									new: true
								});
							}
						}}
					/>
				</div>
			</div>
		);
	}
}

AttachmentItem.propTypes = {
	maxSize: PropTypes.number,
	disabled: PropTypes.bool,
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			filename: PropTypes.string,
			size: PropTypes.number,
			type: PropTypes.number
		})
	),
	baseUrl: PropTypes.string,
	uploadFile: PropTypes.func,
	removeable: PropTypes.bool,
	onAddItem: PropTypes.func,
	onRemoveItem: PropTypes.func
};

AttachmentItem.defaultProps = {
	maxSize: 0,
	disabled: false,
	items: [],
	baseUrl: '/api/attachments/',
	removeable: false,
	uploadFile: Function.prototype,
	onAddItem: Function.prototype,
	onRemoveItem: Function.prototype
};
